/* The contents of this file are generated automatically during the build process of this component.
 * If you need to make changes on these styles, go to the .scss files of this repository.
 * Once you are done, run the "npm run build" script to update this file and commit your changes, including this file.
*/

import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
  `<template>
<style>
/*CSS-START*/
:host {
  display: inline-block;
  cursor: default;
  position: relative;
}

:host([alignment='top']) #wrapper {
  align-items: flex-start;
}

:host([alignment='center']) #wrapper {
  align-items: center;
}

:host([alignment='bottom']) #wrapper {
  align-items: flex-end;
}

:host([disabled]) {
  cursor: default;
  pointer-events: none;
}

:host([disabled]) .checkbox-label {
  color: var(--checkbox-label-disabled-color, var(--secondary-message));
}

:host([error]) .checkbox-label {
  color: var(--checkbox-label-error-color, var(--primary-alert)) !important;
}

:host(:focus) #wrapper,
:host(:focus-within) #wrapper {
  outline-color: var(--checkbox-outline-color, var(--outline-color-theme, Highlight));
  outline-style: var(--outline-style-theme, solid);
  outline-width: var(--outline-width-theme, 2px);
}

.checkbox-label {
  flex-grow: 1;
  color: var(--checkbox-label-color, var(--primary-dark));
  @apply --font-base;
}

#wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

#wrapper #checkboxIcon {
  font-size: var(--checkbox-icon-font-size, 14px);
  position: relative;
  left: var(--checkbox-icon-left);
  top: var(--checkbox-icon-top);
}

#wrapper input {
  margin: var(--checkbox-icon-margin, 0px 10px 0px 0px);
  min-width: 20px;
  width: 20px;
  min-height: 20px;
  height: 20px;
  background: transparent;
  color: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
  border: none;
  border-radius: var(--checkbox-border-radius, 2px);
}

#wrapper input ~ #checkmark {
  width: var(--checkbox-width, 18px);
  height: var(--checkbox-height, 18px);
  border: var(--checkbox-border, solid 1px);
  border-radius: var(--checkbox-border-radius, 2px);
  line-height: var(--checkbox-icon-line-height, 20px);
  border-color: var(--checkbox-unchecked-border-color);
  background-color: var(--checkbox-unchecked-background-color);
  margin: 0;
  position: absolute;
}

#wrapper input:focus {
  outline: var(--checkbox-focus-outline, auto);
}

#wrapper input[checked] {
  background: transparent;
}

#wrapper input[checked] ~ #checkmark {
  border-color: var(--checkbox-checked-border-color);
  background-color: var(--checkbox-checked-background-color);
}

#wrapper input[checked] ~ #checkmark #checkboxIcon {
  color: var(--checkbox-icon-color, white);
}

#wrapper input:disabled:not([checked]) ~ #checkmark {
  border-color: var(--checkbox-unchecked-disabled-border-color);
  background-color: var(--checkbox-unchecked-disabled-background-color);
}

#wrapper input[checked]:disabled ~ #checkmark {
  border-color: var(--checkbox-checked-disabled-border-color);
  background-color: var(--checkbox-checked-disabled-background-color);
}

#wrapper input[checked]:disabled ~ #checkmark #checkboxIcon {
  color: var(--checkbox-icon-disabled-color, white);
}

#wrapper input[error] ~ #checkmark {
  border-color: var(--checkbox-unchecked-error-border-color);
  background-color: var(--checkbox-unchecked-error-background-color);
}

#wrapper input[error][checked] ~ #checkmark {
  border-color: var(--checkbox-checked-error-border-color);
  background-color: var(--checkbox-checked-error-background-color);
}

#wrapper input[error][checked] ~ #checkmark #checkboxIcon {
  color: var(--checkbox-icon-error-color, white);
}

#wrapper input ~ #checkboxImage {
  margin: var(--checkbox-icon-margin, 0px 10px 0px 0px);
}

@media (hover: hover) {
  #wrapper input:hover ~ #checkmark {
    border-color: var(--checkbox-unchecked-hover-border-color);
    background-color: var(--checkbox-unchecked-hover-background-color);
  }
  #wrapper input[checked]:hover ~ #checkmark {
    border-color: var(--checkbox-checked-hover-border-color);
    background-color: var(--checkbox-checked-hover-background-color);
  }
  #wrapper input[checked]:hover ~ #checkmark #checkboxIcon {
    color: var(--checkbox-icon-hover-color, white);
  }
  #wrapper input:disabled:hover:not(:checked) ~ #checkmark {
    border-color: var(--checkbox-unchecked-hover-disabled-border-color);
    background-color: var(--checkbox-unchecked-hover-disabled-background-color);
  }
  #wrapper input[checked]:disabled:hover ~ #checkmark {
    border-color: var(--checkbox-checked-hover-disabled-border-color);
    background-color: var(--checkbox-checked-hover-disabled-background-color);
  }
  #wrapper input[checked]:disabled:hover ~ #checkmark #checkboxIcon {
    color: var(--checkbox-icon-hover-disabled-color, white);
  }
  #wrapper input[error]:hover ~ #checkmark {
    border-color: var(--checkbox-unchecked-hover-error-border-color);
    background-color: var(--checkbox-unchecked-hover-error-background-color);
  }
  #wrapper input[error][checked]:hover ~ #checkmark {
    border-color: var(--checkbox-checked-hover-error-border-color);
    background-color: var(--checkbox-checked-hover-error-background-color);
  }
  #wrapper input[error][checked]:hover ~ #checkmark #checkboxIcon {
    color: var(--checkbox-icon-hover-error-color, white);
  }
}
/*CSS-END*/
</style>
</template>`;

styleElement.register('wdpr-checkbox-style');
